import BusinessBranch from "./BusinessBranch";
import { AnnouncementsAttributes } from "../attributes/announcements-attributes";

class Announcement {
  id: number;
  title: string;
  description: string;
  start_date: Date;
  end_date: Date;
  discount: number;
  images: string;

  constructor(
    id: number,
    title: string,
    description: string,
    start_date: Date,
    end_date: Date,
    discount: number,
    images: string
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.start_date = start_date;
    this.end_date = end_date;
    this.discount = discount;
    this.images = images;
  }

  static fromJson(json: AnnouncementsAttributes) {
    if (json === null || json === undefined) {
      return null;
    }

    return new Announcement(
      json.id,
      json.title,
      json.description,
      json.start_date,
      json.end_date,
      json.discount,
      json.images
    );
  }
}

export default Announcement;
